import { varsFromServer } from './client_side_injection_vars';
import Deferred from './deferred';
import 'whatwg-fetch';

// Remove once location search is merged
import algoliaClient from './util/algolia_client';
export const ALGOLIA_GEOGROUPING_INDEX = varsFromServer.algoliaGeogroupingIndex;
//

const geoDataDefer = new Deferred();

export const geoData = geoDataDefer.promise;

const DEFAULT_GEO = 'US';

function parseOverride(search) {
  if (search.includes('override_country=')) {
    const match = /override_country=([^&]+)/.exec(search);
    if (match && match.length > 1) {
      return match[1];
    }
  }
  return '';
}

export async function fetchGeoData() {
  const overrideCountry = parseOverride(window.location.search);

  if (overrideCountry) {
    geoDataDefer.resolve({
      countryCode: overrideCountry
    });
    return;
  }

  const geoHeadersResponse = await fetch('/', { method: 'head' });
  const geoHeaders = geoHeadersResponse.headers.get('GeoIP-Country-Code') || DEFAULT_GEO;
  geoDataDefer.resolve({
    countryCode: geoHeaders
  });
}

export function updatePhoneNumbersWithGeoData(countryCode) {
  const geoPhoneData = varsFromServer.geoPhoneNumbers;
  const phoneDataForCountry = geoPhoneData.find(phone => phone.iso === countryCode) || {};
  if (phoneDataForCountry.phone) {
    const phoneNumber = phoneDataForCountry.phone;
    /**/
    Array.from(document.querySelectorAll('a.support-phone-number')).forEach(el => {
      el.textContent = phoneNumber;
      el.setAttribute('href', `tel:${phoneNumber}`);
    });
  }
}

export async function performAlgoliaNearbySearch(hitsPerPage = 5) {
  return algoliaClient().search([
    {
      indexName: ALGOLIA_GEOGROUPING_INDEX,
      query: '',
      params: {
        facetFilters: ['type:Marketgeo'],
        aroundLatLngViaIP: true,
        getRankingInfo: true,
        hitsPerPage
      }
    }
  ]);
}
